import { Component, OnInit } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';


import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { ToastrService } from 'ngx-toastr';

import { ApiSplats, ApiSetSplatsRequest } from '../api-client-module';
import { ProjectLanguage } from '../firestore-models/project-language';
import { Splats } from '../firestore-models/splats';

import { ConfigurationService } from '../configuration.service';
import { ApiClientService } from '../api-client.service';
import { SpinnerService } from '../services/spinner.service';

import { AppConst } from '../app-const';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-splats',
  templateUrl: './splats.component.html',
  styleUrls: ['./splats.component.css'],
  standalone: false,
})
export class SplatsComponent implements OnInit {

  //SPLATS情報
  splats?: ApiSplats;
  //各予約設備情報に紐付くプロジェクトID
  projectId: string;
  questionIDs: string[] = [];

  display: string = 'basic';
  isAdded: boolean = true;
  isInit: boolean = true;
  projectLanguages!: Array<ProjectLanguage>;

  //SPLATS情報フォーム
  splatsFormGroup!: FormGroup;
  shareAccessTokenControl!: FormControl;
  productionAccessTokenControl!: FormControl;

  private splatsCollection!: AngularFirestoreCollection<Splats>;

  currentLang: string = 'ja';

  constructor(
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private angularFirestore: AngularFirestore,
    private configurationService: ConfigurationService,
    private apiClientService: ApiClientService,
    private spinnerService: SpinnerService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
    this.projectId = this.configurationService.getProjectId();
    this.splatsFormGroup = this.formBuilder.group({});
   }

  ngOnInit(): void {
    this.splatsCollection = this.angularFirestore.collection<Splats>(
      AppConst.FIRESTORE_SPLATS, ref => ref.where('project_id', '==', this.projectId));
    this.splatsCollection.valueChanges({ idField: 'id' }).subscribe(splasts=> {
      const apiSplats: ApiSplats = {
        id: '',
        project_id: this.projectId,
        share_access_token: '',
        production_access_token: '',   
        enabled: true,
      };

      if (splasts.length > 0) {
        const splat = splasts[0];
        apiSplats.id = splat.id!;
        apiSplats.share_access_token = splat.share_access_token!;
        apiSplats.production_access_token = splat.production_access_token!;
        apiSplats.enabled = splat.enabled;
        this.isAdded = false;

      }
      this.splats = apiSplats;

      this.createForm();
      this.shareAccessTokenControl = this.splatsFormGroup.get('shareAccessToken') as FormControl;
      this.productionAccessTokenControl = this.splatsFormGroup.get('productionAccessToken') as FormControl;
    });
    this.currentLang = this.translate.currentLang;
  }

  ngAfterViewInit(): void {
  }

  //フォームの値を各要素に代入
  private createForm() {
    this.splatsFormGroup = this.formBuilder.group(
      {
        shareAccessToken: [this.splats!.share_access_token, []],
        productionAccessToken: [this.splats!.production_access_token, []],
      }, {
        validator: []
      }
    );
  }

  //追加・更新ボタン
  setSplats(): void {
    this.splats!.share_access_token = this.shareAccessTokenControl.value;
    this.splats!.production_access_token = this.productionAccessTokenControl.value;
    
    let request: ApiSetSplatsRequest = {
      access_token: '',
      change_type: this.isAdded ? AppConst.DATA_CHANGE_TYPE_ADD : AppConst.DATA_CHANGE_TYPE_UPDATE,
      splats: [this.splats!]
    }
    this.spinnerService.openSpinner();
    this.apiClientService.setSplats(request).then(
      response => {
        if (response!.ret === AppConst.API_RET_SUCCESS) {
          this.toastr.success(this.translate.instant('登録しました。'))
        } else {
          this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 })
        }
      }
    ).catch(
      error => {
        console.log(error);
        this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
      }
    ).finally(
      () => {
        this.spinnerService.closeSpinner();
      }
    );
  }
}
